import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { Localized } from 'app/objects';
import { ReligionBranch } from 'app/modules/admin/components/religion-branch/religion-branch.component';
import { LanguageStyle } from '../../services/language-style.service';

@Component({
  selector: 'app-language-style',
  templateUrl: './language-style.component.html',
  styleUrls: ['./language-style.component.css']
})
export class LanguageStyleComponent implements OnInit {

  public entities: LanguageStyle[];
  public isLoading = false;

  constructor(
    public dialog: MatDialog,
    private apiSvc: ApiService
  ) { }


  ngOnInit() {
    this.loadEntities();
  }

  private loadEntities() {
    this.isLoading = true;
    this.apiSvc.get("api/languagestyle", null).subscribe(
      (data: LanguageStyle[]) => {
        this.entities = data;
        console.log(this.entities);
        this.isLoading = false;
      },
      (err) => {
        console.log("error", err);
        this.isLoading = false;
      }
    );
}
 

}
